// 统一的头像处理工具

const API_BASE = 'http://localhost:3001';
const DEFAULT_AVATAR = `${API_BASE}/uploads/demo-avatar.png`;

/**
 * 获取完整的头像URL
 * @param profilePicture - 用户的profilePicture字段
 * @returns 完整的头像URL
 */
export function getAvatarUrl(profilePicture: string | undefined | null): string {
  // 如果没有头像，返回默认头像
  if (!profilePicture) {
    return DEFAULT_AVATAR;
  }

  // 如果是 base64 格式的头像，直接返回
  if (profilePicture.startsWith('data:image/')) {
    return profilePicture;
  }

  // 如果是默认头像路径，返回完整URL
  if (profilePicture === '/uploads/demo-avatar.png' || 
      profilePicture === 'demo-avatar.png' ||
      profilePicture === '/demo-avatar.png') {
    return DEFAULT_AVATAR;
  }

  // 如果已经是完整URL，直接返回
  if (profilePicture.startsWith('http://') || profilePicture.startsWith('https://')) {
    return profilePicture;
  }

  // 如果是相对路径
  if (profilePicture.startsWith('/')) {
    // 确保路径在uploads目录下
    if (profilePicture.startsWith('/uploads/')) {
      return `${API_BASE}${profilePicture}`;
    }
    // 其他路径返回默认头像
    return DEFAULT_AVATAR;
  }

  // 其他情况返回默认头像
  return DEFAULT_AVATAR;
}

/**
 * 获取用户名首字母作为头像文字
 * @param username - 用户名
 * @param email - 邮箱
 * @returns 大写首字母
 */
export function getAvatarLetter(username?: string, email?: string): string {
  if (username && username.length > 0) {
    return username.charAt(0).toUpperCase();
  }
  if (email && email.length > 0) {
    return email.charAt(0).toUpperCase();
  }
  return 'U';
}

/**
 * 检查头像URL是否是默认头像
 * @param profilePicture - 头像路径
 * @returns 是否是默认头像
 */
export function isDefaultAvatar(profilePicture: string | undefined | null): boolean {
  if (!profilePicture) return true;
  return profilePicture === '/uploads/demo-avatar.png' || 
         profilePicture === DEFAULT_AVATAR ||
         profilePicture === '/demo-avatar.png' ||
         profilePicture === 'demo-avatar.png';
}

